import { render, staticRenderFns } from "./purchaseReturnList.vue?vue&type=template&id=39809c3a&scoped=true"
import script from "./purchaseReturnList.vue?vue&type=script&lang=js"
export * from "./purchaseReturnList.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnList.vue?vue&type=style&index=0&id=39809c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39809c3a",
  null
  
)

export default component.exports